<button mat-flat-button color="primary" (click)="onClick($event)">{{ props.label }}</button>

<ng-template #modalWrapper>
  <div flexFill flexLayout="column" flexLayoutAlign="space-between stretch">
    <h1 mat-dialog-title>{{ props.title }}</h1>
    <div mat-dialog-content>
      <ng-container #fieldComponent></ng-container>
    </div>
    <mat-dialog-actions flexLayout="row" flexLayoutAlign="end center">
      <button type="button" mat-button (click)="onClose($event)">Cancel</button>
      <button
        type="button"
        mat-raised-button
        color="primary"
        [disabled]="formControl.invalid"
        (click)="onCommit($event)"
      >
        Commit
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
